import React, { Component } from "react";
import { Modal, Button, Image } from "react-bootstrap";

export default class ConfirmationModal extends Component {
  render() {
    const { confirmShow, confirmonHide, onRemove, modalMessage } = this.props;
    return (
      <div>
        <Modal
          bsSize="small"
          show={confirmShow}
          onHide={confirmonHide}
          className="ConfirmationModal"
        >
          <Modal.Header closeButton>
            <Modal.Title className="Remove">Remove</Modal.Title>
          </Modal.Header>
          <Modal.Body className="Modal-body">
            <h5 className="h5-txt">{modalMessage}</h5>
            <div className="flex-between-center" style={{ marginTop: "30px",padding:"0px 30px" }}>
              <div
                className="green-txt flex-center"
                onClick={confirmonHide}
                style={{
                  width: "16px",
                  paddingBottom: "2px",
                  fontFamily: "CircularStdMedium, Arial, sans-serif",
                  fontSize: "16px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                }}
              >
                <Image
                  src={require("./../../assets/icons/back-left.png")}
                  style={{
                    width: "17px",
                  }}
                />
                Back
              </div>
              <Button className="Rectangle-465" onClick={() => onRemove()}>
                Remove
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
